import { Component, OnInit } from '@angular/core';
import { Validators, FormControl, FormGroup } from '@angular/forms';
import { DynamicDialogRef } from 'primeng/api';
import { DynamicDialogConfig } from 'primeng/api';
import { NewmemberService } from '../../services/newmember.service';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/api';

@Component({
  selector: 'app-cardholderform',
  templateUrl: './cardholderform.component.html',
  styleUrls: ['./cardholderform.component.css'],
  providers: [DialogService]
})
export class CardholderformComponent implements OnInit {
  requestLetterType : string;
  photo  : any;
  photoProof : any;
  associatedProof : any;
  disableMobile: boolean = true;
  addonList: any = [];
  pmStateList: any = [];
  pmCityList: any = [];
  pmCountyList: any = [];
  pmStateDropDisable:boolean = true;
  pmCityDropDisable:boolean = true;
  populateForm: any = {};
  nameblock: RegExp = /^[^<>*!@#$_%+=~`^{};:.,&|?\[\]'"]+$/;
  blockSpecial: RegExp = /^[^0-9<>*!@#$_%+=~`^{}()-/\\;:.,&|?\[\]'"]*$/;
  pmForm: FormGroup;
  pmFormValid: boolean = true;
  docUpdated: boolean = false;
  pidExpiryDisable: boolean = false;
  draftMandatory: boolean = true;
  pm: any = {};
  uploadedFiles: any = {};
  cardLicence:any = {};
  PMverified: boolean = true;
  PMverifiedNo: string;
  editContact: boolean;
  cardStatus: any = [];
  existingCardStatus: string;
  cardDropByStatus: any = [];
  yearlimit: string;
  agelimit: any;
  yearRange: any;
  memberDetails: any = {};
  showCardStatusDrop: boolean = true;
  relationshipWithCompany:any = [
    {label: 'OWNER', value: 'OWNER'},
    {label: 'EMPLOYEE', value: 'EMPLOYEE'},
    {label: 'PARTNER', value: 'PARTNER'}
  ];
  completeAplhaNumeric: RegExp = /^[^<>*!@#$_%+=~`^{}()\\\/;:.,&|?\[\]'"]+$/;
  alphaNumberic: RegExp = /[a-z0-9]/i;
  addressLine1:string;
  addressLine2:string;
  cityName: string;
  countyName: string;
  postalCode: number;
  stateProvCode: string;
  
  constructor(private confirmationService: ConfirmationService,
    public dialogService: DialogService, public ref: DynamicDialogRef, public config: DynamicDialogConfig, public nms: NewmemberService, public messageService: MessageService) { }

  ngOnInit() {
    this.pmForm = new FormGroup({
      firstName: new FormControl('', Validators.compose([
        Validators.required
      ])),
      middleName: new FormControl(),
      lastName: new FormControl('', Validators.compose([
        Validators.required
      ])),
      // relation: new FormControl('', Validators.compose([
      //   Validators.required
      // ])),
      mobile: new FormControl('', Validators.compose([
        Validators.required,
        Validators.pattern('^[5-9][0-9]{9}$')
      ])),
      dob: new FormControl('', Validators.compose([
        Validators.required
      ])),
      buildingno: new FormControl('', Validators.compose([
        Validators.required
      ])),
      streetname: new FormControl('', Validators.compose([
        Validators.required
      ])),
      city: new FormControl('', Validators.compose([
        Validators.required
      ])),
      county: new FormControl('', Validators.compose([
        Validators.required
      ])),
      state: new FormControl('', Validators.compose([
        Validators.required
      ])),
      pinno: new FormControl('', Validators.compose([
        Validators.required,
        Validators.pattern('^[0-9]{6}$')
      ])),
      docType: new FormControl('', Validators.compose([
        Validators.required
      ])),
      STDLandLine: new FormControl(),
      whatsappNumber: new FormControl({ disabled: true }),
      mailId: new FormControl('', Validators.compose([
        Validators.pattern('^[A-Za-z0-9._-]+[@][A-Za-z0-9._-]+[.][a-zA-Z]{2,5}$')
      ])),
      cardLic: new FormControl('', Validators.compose([
        Validators.required
      ])),
      cardExpiry: new FormControl('', Validators.compose([
        Validators.required
      ])),
      cardState: new FormControl('', Validators.compose([
        Validators.required
      ])),
      relationship: new FormControl(),
      education: new FormControl({ disabled: true }),
      cardStatus:  new FormControl('', Validators.compose([
        Validators.required
      ])),
      income: new FormControl({ disabled: true }),
      social: new FormControl({ disabled: true }),
      isBusinessOwner: new FormControl(false),
      attestation: new FormControl({ value: false, disabled: true }),
    });
    this.cardStatus = [
      { label: 'Active', value: 'A' }
    ];
    var date = new Date();
    date.setFullYear(date.getFullYear() - 18);
    this.agelimit = date;
    this.yearlimit = (this.agelimit.getFullYear() - 82) + ":" + this.agelimit.getFullYear();
    this.addonList = this.config.data.memberDetails.cardHolderInfo;  
    
    this.populateForm = this.config.data.populateForm;
    this.editContact = this.config.data.editContact;
    if (this.config.data.memberDetails != null && 
      this.config.data.memberDetails.cardHolderInfo != null) {
      this.memberDetails = this.config.data.memberDetails;
      for (let mem of this.config.data.memberDetails.cardHolderInfo) {
        if (mem.cardHolderNbr == this.config.data.cardId) {
          this.pm = JSON.parse(JSON.stringify(mem));

          this.pmStateList = [];
          this.pmStateList.push(this.pm.stateProvCode);

          this.pmCityList = [];
          this.pmCityList.push(this.pm.cityName);

          this.getCountyByPincode(this.pm.postalCode);

         //this.amCountyList = this.config.data.businessCountyList;
         this.addressLine1 = this.pm.addressLine1;
         this.addressLine2 = this.pm.addressLine2;
         this.cityName = this.pm.cityName;
         this.stateProvCode = this.pm.stateProvCode;
         this.postalCode = this.pm.postalCode;
         this.countyName = this.pm.countyName;

          this.existingCardStatus = mem.status;
          if (this.existingCardStatus == "A") {
            this.cardDropByStatus = [
              { label: 'Lost', value: 'L' },
              { label: 'Stolen',value: 'S' },
              { label: 'Revoked',value: 'R' }
            ];
          } else if (this.existingCardStatus == "P") {
            this.pm.status = "";
            this.cardDropByStatus = [
              { label: 'Draft', value: 'DRAFT' }
            ];
          } else if (this.existingCardStatus == "DRAFT") {
            this.cardDropByStatus = [
              { label: 'Draft', value: 'DRAFT' }
            ];
          }
          if (this.existingCardStatus == "ONHOLD") {
            this.pmForm.get('cardStatus').setValidators(null);
            this.showCardStatusDrop = false;
          }
          this.cardStatus = this.cardStatus.concat(this.cardDropByStatus);
          this.PMverifiedNo = this.pm.phoneNbr;
        }
      }
      if (this.pm.status == "" || this.pm.status === "DRAFT" || this.pm.cardHolderNbr > 100) {
        this.disableMobile = false;
      }
      if (this.addonList.length > 0) {
        var addOn = this.addonList.filter(proj => proj.phoneNbr === parseInt(this.pm.phoneNbr));
        if (addOn[0] != null) {
          if (addOn[0].cardHolderNbr != this.pm.cardHolderNbr){
            //this.disableMobile = false;
           // this.messageService.add({ severity: 'error', summary: 'Add Add-on', detail: 'Mobile number is already used by another card holder, please change the mobile number in the change mobile number.' });
          }
        }
      } 

    }

    

    if (this.pm.cardHolderDocuments) {
      this.uploadedFiles.cardHolderDocuments = this.pm.cardHolderDocuments;
      for (let list of this.uploadedFiles.cardHolderDocuments) {
        if(list.documentType === "PHOTO") {
          this.photo = list;
        } else if(list.documentType === "PHOTO PROOF") {
          this.photoProof = list;
        } else if(list.documentType === "ASSOCIATED PROOF") {
          this.associatedProof = list;
        }
        list.ustatus = true;
      }
    } else {
      this.pm.cardHolderDocuments = [];
      this.uploadedFiles.cardHolderDocuments = [];
    }
    
    
    if(this.pm.cardHolderType != 'P') {
      this.pmForm.get('relation').setValidators([Validators.required]);
    }
    for (let list of this.populateForm.photoIdTypes) {
      if (list.code == this.pm.photoTypeCode) {
        if(list.defaultExpiryYear > 0) {
          this.pidExpiryDisable = true;
          if (this.pm.expirationDt == null) {
            let currDate = new Date(localStorage.getItem('currDate'));
            this.pm.expirationDt = new Date(currDate.setFullYear(currDate.getFullYear() + list.defaultExpiryYear));
          }
        } else {
          this.pidExpiryDisable = false;
        }
        if(list.maxLength > 0) {
          this.pmForm.get('cardLic').setValidators([Validators.required,Validators.pattern('^[0-9a-zA-Z]{'+list.maxLength+'}$')]);
        } else {
          this.pmForm.get('cardLic').setValidators([Validators.required]);
        }
        break;
      }
    }
    let currentDate = new Date();
    let yearLimit = currentDate.getFullYear()+10
    this.yearRange = currentDate.getFullYear() + ":" + yearLimit;
    this.pm.landlineNbr = this.pm.phoneNbr;
    
  }
  ngOnChanges() {
    
  }

  getCountyByPincode(pincode) {
    if (pincode != undefined && pincode.toString().length == 6) {
      this.nms.getLocationByPincode(pincode).subscribe((res: any) => {

        if (res.code === "SUCCESS") {
          this.pmCountyList = [];
          this.pmCountyList = res.response.countyNames;
            if (this.pmCountyList.indexOf(this.pm.countyName) < 0) {
              this.pmCountyList.push(this.pm.countyName);
            }
        } 
      });
    }
  }

  isPhoneNumberUnique(phoneNbr, cardholderNbr) {
    if (this.addonList.length > 0) {
      var addOn = this.addonList.filter(proj => proj.phoneNbr === parseInt(phoneNbr));
      if (addOn[0] != null) {
        for (var index = 0; index < addOn.length; index++) {
          if (addOn[index].status != 'L' && addOn[index].status != 'R' && addOn[index].status != 'S'
           && addOn[index].cardHolderNbr != cardholderNbr){
            this.messageService.add({ severity: 'error', summary: 'Edit Add-on', detail: 'Mobile number is already used by another card holder(' + addOn[index].firstName + '), please change the mobile number.' });
            return false;
          }
        }
      }
    } 
    return true;
  }

  ustatusUpdate(event, group, type) {
    if (event) {
      this.docUpdated = true;
    }
    if (!this.uploadedFiles[group]) {
      this.uploadedFiles[group] = [];
      this.uploadedFiles[group].push({ "ustatus": event, "documentType": type });
    } else {
      let check = 0;
      for (let list of this.uploadedFiles[group]) {
        if (list.documentType == type) {
          check = 1;
          list.ustatus = event;
        }
      }
      if (check == 0) {
        this.uploadedFiles[group].push({ "ustatus": event, "documentType": type });
      }
    }
  }

  updatePhotoId(event) {
    for (let list of this.populateForm.photoIdTypes) {
      if (list.code == event.value) {
        let currDate = new Date(localStorage.getItem('currDate'));
        this.pm.expirationDt = new Date(currDate.setFullYear(currDate.getFullYear() + list.defaultExpiryYear));
        if(list.defaultExpiryYear > 0) {
          this.pidExpiryDisable = true;
        } else {
          this.pidExpiryDisable = false;
          this.pm.expirationDt = '';
        }
        if(list.maxLength > 0) {
          this.pmForm.get('cardLic').setValidators([Validators.required,Validators.pattern('^[0-9a-zA-Z]{'+list.maxLength+'}$')]);
        } else {
          this.pmForm.get('cardLic').setValidators([Validators.required]);
        }
        break;
      }
    }
  }
  
  revokeTriggered() {
    if(this.pm.status == 'R' && this.pm.cardHolderType == 'P') {
      this.confirmationService.confirm({
        message: "If you revoke card " + this.pm.cardHolderNbr + " , you will be prompted to enter a new primary cardholder, Continue?",
        acceptLabel: 'Yes',
        rejectLabel: 'No',
        reject: () => {  
          for (let mem of this.config.data.memberDetails.cardHolderInfo) {
            if (mem.cardHolderNbr == this.config.data.cardId) { 
              this.pm.status = mem.status;
            }
          }
        }
      });
    } else if (this.pm.status == 'L') {
      this.requestLetterType =  "LOST REQUEST LETTER";
    } else if (this.pm.status == 'S') {
      this.requestLetterType =  "STOLEN REQUEST LETTER";
    } else if (this.pm.status == 'R') {
      this.requestLetterType =  "REVOKE REQUEST LETTER";
    } else {
      this.requestLetterType = "";
    }
  }

  updateUploadstatus(event, group, type) {
    if (!this.uploadedFiles[group]) {
      this.uploadedFiles[group] = [];
      this.uploadedFiles[group].push({ "documentId": event.documentId, "documentType": type, "noOfPages": event.noOfPages });
    } else {
      let done = 0;
      for (let list of this.uploadedFiles[group]) {
        if (list.documentType == type) {
          list.documentId = event.documentId;
          done = 1;
        }
      }
      if (done == 0) {
        this.uploadedFiles[group].push({ "documentId": event.documentId, "documentType": type, "noOfPages": event.noOfPages });
      }
    }
  }

  resetOTP(type) {
    this.PMverified = false;
    if (this.PMverifiedNo == this.pm.phoneNbr) {
      this.PMverified = true;
    }
    if(this.pm.cardHolderType=='A') {
      this.PMverified = true;
    }
  }

  updateOTPstatus(event, id) {
    this.PMverified = event;
  }

  saveContact() {
    if (this.pmForm.get('mobile').valid && this.pmForm.get('mailId').valid) {
      this.nms.saveContact(this.pm.cardHolderNbr, this.pm.phoneNbr, this.pm.email).subscribe((res: any) => {
        if (res.code == "SUCCESS") {
          this.ref.close(true);
        }
      }, err => {
        console.error('ERROR', err);
      });
    } else if (this.pmForm.get('mobile').valid) {
      this.msgToast('Please fill valid mobile number and email');
    } else {
      this.msgToast('Please fill valid mobile number and email');
    }
  }

  saveCard() {
    if (this.pmForm.valid && (this.pm.cardHolderType == "P" || (this.pm.relationship && this.pm.relationship != ''))) {
      if (this.pm.cardHolderType == "P" || this.config.data.pnumber != this.pm.phoneNbr) {

        if (this.pm.cardHolderType != "P"
        && this.pm.cardHolderNbr > 100 && 
        !this.isPhoneNumberUnique(this.pm.phoneNbr, this.pm.cardHolderNbr)){
         return;
       }
        if (this.pm.status != "R") {
          if (this.uploadedFiles.cardHolderDocuments) {
            for (let list of this.uploadedFiles.cardHolderDocuments) {
              if (!list.ustatus) {
                this.pmFormValid = false;
                return;
              }
            }
            var photo = this.uploadedFiles.cardHolderDocuments.filter(proj => proj.documentType === "PHOTO");
            var photoProof = this.uploadedFiles.cardHolderDocuments.filter(proj => proj.documentType === "PHOTO PROOF");
            if (photo[0].length == 0 || photoProof.length == 0) {
              this.pmFormValid = false;
              return;
            }
          } else {
            this.pmFormValid = false;
            return;
          }
          if (!this.pmForm.dirty && !this.docUpdated) {
            this.msgToast('No changes made');
            return;
          }
        } else if (!this.pmForm.dirty && !this.docUpdated) {
          this.msgToast('No changes made');
          return;
        }
        if (this.existingCardStatus != this.pm.status) {
          var messageText = "";
          if (this.pm.status == "L") {
            messageText = "Do you want to mark card " + this.pm.cardHolderNbr + " as Lost and create a new card?";
          } else if (this.pm.status == "R") {
            messageText = "Do you want to mark card " + this.pm.cardHolderNbr + " as Revoked?";
          } else if (this.pm.status == "S") {
            messageText = "Do you want to mark card " + this.pm.cardHolderNbr + " as Stolen and create a new card?";
          }
          if (messageText != "") {
            this.confirmationService.confirm({
              message: messageText,
              acceptLabel: 'Yes',
              rejectLabel: 'No',
              accept: () => {
                  this.saveCardInfo('status change');
              },
              reject: () => {            
              }
            });
          } else {
            this.saveCardInfo();
          }
        } else {
          this.saveCardInfo();
        }
      } else {
        if (this.pm.cardHolderNbr > 100) {
          this.msgToast('Phone number same as primary phone number.');
        }
        
      }
    } else {
      if(this.pmForm.get('cardStatus').value == "DRAFT") {
        if (!this.pmForm.dirty && !this.docUpdated) {
          this.msgToast('No changes made');
          return;
        }
        if(this.pmForm.get('firstName').valid && this.pmForm.get('lastName').valid && this.pmForm.get('mobile').valid && this.pmForm.get('relation').valid) {
          if (this.config.data.pnumber == this.pm.phoneNbr) {
            this.msgToast('Phone number same as primary phone number.');
            return;
          }
          if (!this.isPhoneNumberUnique(this.pm.phoneNbr, this.pm.cardHolderNbr)){
            return;
          }
          this.saveCardInfo();
        } else {
          this.draftMandatory = false;
          this.msgToast('Please fill all mandatory fields');
        }
      } else {
        this.pmFormValid = false;
        if (this.pmForm.get('mailId').valid) {
          this.msgToast('Please fill all mandatory fields');
        } else {
          this.msgToast('Invalid Email ID');
        }
      }
    }
  }

  saveCardInfo(process?: string) {
    this.pm.cardHolderDocuments = [];
    if(this.uploadedFiles.cardHolderDocuments.length != 0) {
      this.uploadedFiles.cardHolderDocuments.forEach((list, i) => {
        this.pm.cardHolderDocuments.push(list);
        /*if (list.documentType == "PHOTO") {
          this.pm.cardHolderDocuments[0] = list;
        } else if (list.documentType == "PHOTO PROOF") {
          this.pm.cardHolderDocuments[1] = list;
          this.pm.cardHolderDocuments[1].licenseNumber = list.licenseNumber;
          this.pm.cardHolderDocuments[1].expirationDate = list.expirationDate;
          this.pm.cardHolderDocuments[1].stateProvCode = list.stateProvCode;
        } else if (list.documentType == "ASSOCIATED PROOF") {
          this.pm.cardHolderDocuments[2] = list;
        }*/
      });
    }
    if (this.pm.cardHolderType == 'P') {
      this.nms.savePM(this.pm).subscribe((res: any) => {
        if (res.code == "SUCCESS") {
          this.ref.close(true);
        }
      }, err => {
        console.error('ERROR', err);
      });
    } else {
      if(process == 'status change') {
        this.nms.saveAM(this.pm).subscribe((res: any) => {
          if (res.code == "SUCCESS") {
            this.ref.close(res);
          }
        }, err => {
          console.error('ERROR', err);
        });
      } else {
        let msg = '';
        if(this.pm.status == 'DRAFT') {
          msg = 'Are you sure to save the changes?';
        } else {
          msg = 'Add-on will be moved to QC Pending status, Continue?';
        }
        this.confirmationService.confirm({
          message: msg,
          acceptLabel: 'Yes',
          rejectLabel: 'No',
          accept: () => {  
            this.nms.saveAM(this.pm).subscribe((res: any) => {
              if (res.code == "SUCCESS") {
                this.ref.close(res);
              }
            }, err => {
              console.error('ERROR', err);
            });
          }
        });
      }
    }
  }

  msgToast(msg) {
    this.messageService.add({ severity: 'error', summary: 'Edit Member', detail: msg });
  }

  changeState(state){

    this.pmCityList = [];

  this.nms.getCityByState(state).subscribe((res: any) => {
    if (res.code === "SUCCESS") {
        this.pmCityList = res.response;
    }
  });
}

changeCity(cityName){
    this.pmCountyList = [];

  this.nms.getCountyListByCity(cityName).subscribe((res: any) => {
    if (res.code === "SUCCESS") {
        this.pmCountyList = res.response;
    }
  });
}

populateLocation(res) {
  this.pm.stateProvCode = "";
  this.pm.cityName = "";
  this.pmStateList = [];
  this.pmCityList = [];
  this.pm.countyName = "";

  this.pmStateDropDisable = true;
  this.pmCityDropDisable = true;    
  this.pmStateList.push(res.stateName);
  this.pm.stateProvCode = res.stateName;
  this.pmCityList.push(res.cityName);
  this.pm.cityName = res.cityName;
  this.pmCountyList = res.countyNames;
}

contactInfo() {
  var otpInfo: any = {};
  otpInfo.phoneNbr = this.pm.phoneNbr;
  otpInfo.maMembershipId = this.nms.mlid;
  otpInfo.category = "ONBOARDING_OTP";
  return otpInfo;
 }

getLocationByPincode(pincode, isDirty){
  if (!isDirty) {
    return;
  }
  if (pincode && pincode.length == 6) {
    this.nms.getLocationByPincode(pincode).subscribe((res: any) => {
      this.countyName = "";
   
      if (res.code === "SUCCESS") {
        this.populateLocation(res.response);
      } else {
        this.messageService.add({ severity: 'info', summary: 'Add-on', detail: 'Select State and City.' });
          this.pmStateList = [];
          this.pmCityList = [];
          this.pmCountyList = [];
          this.pmStateDropDisable = false;
          this.pmCityDropDisable = false;
          this.pm.cityName = "";
          this.pm.stateProvCode = "";
          this.pm.countyName = "";
          this.pmStateList = this.populateForm.states;
        
      }
    });
  }
}
}
